import React from 'react';
import { ThumbsUpIcon } from '@/icons/ThumbUp';
import { Button, ButtonProps } from '../../wag-react/next-components/button';
import { theme } from '../../wag-react/themes/base-theme';
import { Typography } from '../../wag-react/components/Typography';
import { Flex } from '../../wag-react/next-components/Flex';
export type ThumbsButtonProps = ButtonProps & {
  direction: 'up' | 'down';
  active?: boolean;
};
export const ThumbsButton = ({
  direction,
  active,
  ...props
}: ThumbsButtonProps) => {
  let color = direction === 'up' ? '#4EB387' : '#CE5757';
  let backgroundColor: string = theme.colors.white;
  if (active) {
    backgroundColor = color;
    color = theme.colors.white;
  }
  return <Button borderRadius="100px" backgroundColor={backgroundColor} border="1px solid #EBF3EE" width="50px" height="50px" minWidth="50px" {...props} data-sentry-element="Button" data-sentry-component="ThumbsButton" data-sentry-source-file="ThumbsButton.tsx">
      <Flex flexDirection="column" alignItems="center" data-sentry-element="Flex" data-sentry-source-file="ThumbsButton.tsx">
        <ThumbsUpIcon color={color} height="20px" style={{
        transform: direction === 'up' ? 'unset' : 'rotateX(180deg)'
      }} data-sentry-element="ThumbsUpIcon" data-sentry-source-file="ThumbsButton.tsx" />
        <Typography color={color} fontSize="10px" fontWeight="bold" mt="1px" mb="0" data-sentry-element="Typography" data-sentry-source-file="ThumbsButton.tsx">
          {direction === 'up' ? 'YES' : 'NO'}
        </Typography>
      </Flex>

    </Button>;
};